import { SVGProps, Ref, forwardRef } from 'react';

export const LockOpenedOutlinedSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.61 1.843c.244.44.404 1.012.484 1.657H12C11.795 1.628 10.967 0 9.052 0 7.292 0 6.45 1.379 6.166 3.057A19 19 0 0 0 4.5 3C.563 3 0 3.563 0 7.5S.563 12 4.5 12 9 11.438 9 7.5c0-2.846-.294-3.929-1.943-4.31.088-.519.234-.98.438-1.347C7.83 1.242 8.301.9 9.052.9s1.223.342 1.557.943m-9.576 3.46C.936 5.82.9 6.522.9 7.5s.036 1.68.134 2.198c.096.51.236.752.376.892s.383.28.892.376c.519.098 1.22.134 2.198.134.977 0 1.68-.036 2.198-.134.51-.096.752-.236.892-.376s.28-.383.376-.892c.098-.519.134-1.22.134-2.198 0-.977-.036-1.68-.134-2.198-.096-.51-.236-.752-.376-.892s-.383-.28-.892-.376C6.179 3.936 5.478 3.9 4.5 3.9c-.977 0-1.68.036-2.198.134-.51.096-.752.236-.892.376s-.28.383-.376.892M4.95 8.75h-.9v-2.5h.9z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
LockOpenedOutlinedSize12Glyph.displayName = 'LockOpenedOutlinedSize12Glyph';
